import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyKaffirLimeIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./KaffirLimeIcon-523df2bc.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyKaffirLimeIcon as P };
